const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://api.resto-online.be";
//const BACKEND = "http://localhost:6969";  

const getPathSegment = () => {
    const path = window.location.pathname.split("/")[1]; // Pak eerste segment na "/"
    console.log('Current path segment:', path); // Debug logging
    return path ? path.toLowerCase() : null; // Convert to lowercase and return null if no segment
};


// Fetch collections
export const fetchCollections = async ({ signal }) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/collections`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de collecties.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

// Fetch products
export const fetchProducts = async ({ signal }) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/products`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de producten.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

// Fetch menus
export const fetchMenus = async ({ signal }) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/menus`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de menu's.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

// Fetch shop info
export const fetchShopInfo = async () => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/info`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de shop informatie.");
        error.code = response.status;
        error.info = await response.json();
        
        // If it's a 404 error, redirect to NotFound page
        if (error.code === 404) {
            window.location.href = '/not-found';
            return;
        }
        
        throw error;
    }

    return response.json();
};

// Fetch pickup slots
export const fetchShopPickupSlots = async ({ signal }) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/pickup-slots`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de ophaalmomenten.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

// Fetch opening hours
export const fetchOpeningHours = async ({ signal }) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/opening-hours`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de openinguren.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

// Fetch vacation mode
export const fetchShopVacationMode = async ({ signal }) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/vacation-mode`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de vakantie modus.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

// Fetch opening hours
export const fetchShopOpeningHours = async ({ signal }) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/opening-hours`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de openingsuren.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

export const placeOrder = async (orderData) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/orders`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(orderData),
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het plaatsen van de bestelling.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};

// Fetch discounts
export const fetchDiscounts = async ({ signal }) => {
    const subdomain = getPathSegment();

    const response = await fetch(`${BACKEND}/shop/${subdomain}/discounts`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
        signal,
    });

    if (!response.ok) {
        const error = new Error("Er is iets misgegaan tijdens het ophalen van de kortingen.");
        error.code = response.status;
        error.info = await response.json();
        throw error;
    }

    return response.json();
};
